import { Spinner } from '@change/ds-core-ui';

import { withPrefetchedData } from 'src/shared/prefetch';

import type { SearchPagePrefetchedDataProps } from 'src/app/pages/search/pageContext';
import { prefetchPageContext, SearchPageContextProvider } from 'src/app/pages/search/pageContext';

import { Layout } from '../layout';

import { SearchErrorHandler } from './ErrorHandler';

export const Search = withPrefetchedData(
	function Search({ prefetchedData }: SearchPagePrefetchedDataProps) {
		return (
			<SearchPageContextProvider
				prefetchedData={prefetchedData}
				errorHandler={SearchErrorHandler}
				loadingFallback={<Spinner className="mx-auto my-64" />}
			>
				<Layout />
			</SearchPageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,

		prefetchData: async (context) => prefetchPageContext(context),
	},
);
